// src/components/ui/ProtectedRoute.tsx

import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';

/**
 * 路由守卫组件
 * 保护需要认证的路由
 */
export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};